import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { HeroSection } from "@/components/landing/HeroSection";
import { TrustBand } from "@/components/landing/TrustBand";
import { BeforeAfterSection } from "@/components/landing/BeforeAfterSection";
import { ModulesSection } from "@/components/landing/ModulesSection";
import { AdvisorSection } from "@/components/landing/AdvisorSection";
import { EcosystemSection } from "@/components/landing/EcosystemSection";
import { PlatformShowcaseSection } from "@/components/landing/PlatformShowcaseSection";
import { MobileAppSection } from "@/components/landing/MobileAppSection";
import { AppShowcaseSection } from "@/components/landing/AppShowcaseSection";
import { PricingSection } from "@/components/landing/PricingSection";
import { DemoSection } from "@/components/landing/DemoSection";
import { SEO } from "@/components/SEO";

export default function LandingPage() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-[#050505]" data-testid="landing-page">
      <SEO description="PUNCH, CRM, ERP, COMPTA et DEVIS AI réunis dans un seul écosystème intelligent pensé pour la construction au Québec. Un seul portail, une seule connexion, conforme Loi 25 et TPS/TVQ." />
      <Header />
      <main>
        <HeroSection />
        <TrustBand />
        <BeforeAfterSection />
        <ModulesSection />
        <AdvisorSection />
        <EcosystemSection />
        <PlatformShowcaseSection />
        <MobileAppSection />
        <AppShowcaseSection />
        <PricingSection />
        <DemoSection />
      </main>
      <Footer />
    </div>
  );
}
